<!-- eslint-disable -->
<template>
  <div></div>
</template>
<style lang="less" scoped></style>
<script>
import { getToken } from '@/assets/js/auth';
import { legalMap } from '@/common/constant';

export default {
  data() {
    return {};
  },
  async created() {
    let legalHost = legalMap[window.location.host];
    if (legalHost) {
      window.location = `${legalHost}/admin/cros?token=${getToken()}`;
    }
  },
  methods: {}
};
</script>
